import { useQuery } from "@apollo/client";
import { useMemo } from "react";
import { EntityTypeFilterValue } from "../../../../legacy/types/companyFilter";
import { VENDOR_COMPANY_COUNT_QUERY } from "../queries/vendorCompanyCountQuery";
import { COMPANY_SEARCH_CLIENT } from "../../../../utils/consts";

function useCompanyCountQuery(
  vendorId: number,
  localizeInstalls: boolean,
  entityTypeFilterValue: EntityTypeFilterValue
) {
  const { data, loading } = useQuery(VENDOR_COMPANY_COUNT_QUERY, {
    variables: {
      vendorId,
      localizeInstalls,
      ...entityTypeFilterValue,
    },
    skip: vendorId === 0,
    context: { clientName: COMPANY_SEARCH_CLIENT },
  });

  const count = useMemo(
    () => data?.opportunityGeneratorSearch.count || 0,
    [data]
  );

  return { count, loading };
}

export default useCompanyCountQuery;
